import { useSelector } from 'react-redux';
import { selectStaticResidentialProxies } from 'store/slices/PricingSlice';
import ProductPricingCard from '../../ProductPricingCard';
import { selectCurrentStaticResidentialProxies } from 'store/slices/GeneralSlice';
import StaticResidentialTab from './Tab';

const StaticPricingCard = ({ sliderValue, onChange }) => {
    const data = useSelector(selectStaticResidentialProxies);
    const staticResidentialProxies = useSelector(selectCurrentStaticResidentialProxies)

    return (
        <ProductPricingCard
            data={data}
            fields={staticResidentialProxies}
            sliderValue={sliderValue}
            additionalComponent={<StaticResidentialTab sliderValue={sliderValue} onChange={onChange} />}
        />
    );
};

export default StaticPricingCard;
